/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import loaded from './loaded';


export default combineReducers({
	loaded,
});
